import {
    Directive,
    Input,
    Renderer2,
    AfterViewInit,
    OnDestroy,
    Inject,
} from "@angular/core";

import { fromEvent, Subscription } from "rxjs";

import { Context, WINDOW } from "@hermes/app-core";

@Directive({
    selector: "[hImageGalleryScroll]",
})
export class ImageGalleryScrollDirective implements AfterViewInit, OnDestroy {
    @Input()
    public animationElement!: HTMLElement;
    @Input()
    public containerElement!: HTMLElement;
    public inputCurrentIndex: number = 0;

    private readonly subscription = new Subscription();

    constructor(
        private readonly renderer: Renderer2,
        private context: Context,
        @Inject(WINDOW) private readonly window: Window,
    ) {}

    @Input()
    public set currentIndex(index: number) {
        this.inputCurrentIndex = index;
        if (this.context.isInBrowserMode()) {
            this.updateAnimationPosition();
        }
    }

    public ngAfterViewInit(): void {
        if (this.context.isInBrowserMode()) {
            this.updateAnimationPosition();

            this.subscription.add(
                fromEvent(this.window, "resize").subscribe(() =>
                    this.updateAnimationPosition(),
                ),
            );
        }
    }

    public updateAnimationPosition(): void {
        if (!this.containerElement || !this.animationElement) {
            return;
        }

        const activeElement = this.containerElement.children[
            this.inputCurrentIndex
        ] as HTMLElement;

        if (!activeElement) {
            return;
        }

        const itemWidth = activeElement.offsetWidth;

        const activeRect = activeElement.getBoundingClientRect();
        const containerRect = this.containerElement.getBoundingClientRect();

        const translateX = activeRect.left - containerRect.left;
        const translateY = activeRect.top - containerRect.top + 4;

        this.renderer.setStyle(
            this.animationElement,
            "width",
            `${itemWidth}px`,
        );
        this.renderer.setStyle(
            this.animationElement,
            "transform",
            `translate3d(${translateX}px, ${translateY}px, 0)`,
        );
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
